import apiRequest from './apiRequest';

/** Organization row from admin detail / actions; usage-billing fields are present for workspace orgs. */
export type AdminUserManagementOrganizationRecord = Record<string, unknown> & {
  organizationID?: string;
  organizationName?: string;
  availableCredits?: number;
  currentCreditBalance?: number;
  purchasedCredits?: number;
  costPerCredit?: number;
  topUpAmountUSD?: number;
  monthlyCreditRefreshAmount?: number;
  pendingOrgCreditTopUpPaymentIntentId?: string;
  lastAppliedOrgCreditTopUpPaymentIntentId?: string;
  planType?: string;
};

export type AdminUserManagementUserDetail = {
  user: Record<string, unknown>;
  organization?: AdminUserManagementOrganizationRecord;
  organizationMembers?: Array<{
    userID: string;
    accessLevel: string;
    firstName: string;
    lastName: string;
    preferredName: string;
    planType: string;
    email: string;
  }>;
};

export type AdminUserManagementOrganizationDetail = {
  organization: AdminUserManagementOrganizationRecord;
  members: Array<{
    userID: string;
    accessLevel: string;
    firstName: string;
    lastName: string;
    preferredName: string;
    planType: string;
    email: string;
  }>;
  serviceAccounts: Array<{
    serviceID: string;
    serviceName: string;
    accountBalanceUSD: number;
    apiKeyLast4Digits: string;
    createdAt: string;
    createdBy: string;
    invalidAfter: string;
    accessLevel: string;
    allowedOverdraftUSD?: number;
    numParallelJobs?: number;
    organizationID: string;
    topUpAmountUSD?: number;
  }>;
};

export default async function getAdminUserManagementDetail(
  type: 'user' | 'organization',
  id: string,
) {
  const params = new URLSearchParams({ type, id });
  return apiRequest<
    AdminUserManagementUserDetail | AdminUserManagementOrganizationDetail
  >('user', `/admin/userManagement/detail?${params.toString()}`);
}
